<template>
  <header class="header-wrapper">
    <div class="header">
      <div class="menu-button" @click="toogleMenu">
        <i v-if="isMenuOpen" class="fas fa-chevron-up"></i>
        <i v-else class="fas fa-bars"></i>
      </div>

      <div class="logo-container">
        <img src="../../assets/img/logo_green.png" alt="">

        <div class="beta">
          <img src="../../assets/img/beta.svg" alt="">
        </div>
      </div>
    </div>
  </header>
</template>

<script>
  export default {
    name: "Header",

    props: ['isMenuOpen'],

    methods: {
      toogleMenu() {
        this.$emit('toogle-menu');
      },
    },
  };
</script>

<style lang="scss">
  @import "../../assets/scss/variables.scss";

  .header-wrapper {
    position: fixed;
    z-index: 10001;
    height: 50px;
    width: 100%;

    .header {
      position: relative;
      height: 100%;
      max-width: $max-width;
      margin: 0 auto;
      padding: 15px 0 0;
      background-color: $dark;

      .menu-button {
        position: absolute;
        left: 20px;
        top: 14px;
        font-size: 16px;
        color: $primary;
      }

      .logo-container {
        position: relative;
        width: 125px;
        height: 20px;
        margin: 0 auto;
        padding: 0;
        text-align: center;

        img {
          height: 100%;
        }

        .beta {
          position: absolute;
          left: 100%;
          top: -7px;
          width: 40px;
          height: 22px;
          margin-left: -15px;
          text-align: left;

          img {
            height: 100%;
          }
        }
      }
    }
  }
</style>
